import { module } from 'modujs';
import { html } from '../utils/environment';
import LocomotiveScroll from 'locomotive-scroll';
import ScrollCall from '../classes/HorizontalScrollCall';
import { lazyLoadImage } from '../utils/image';


export default class extends module {
    constructor(m) {
        super(m);

        this.onHScrollCall = this.onHScrollCall.bind(this)

        this.direction = this.getData('horizontal') == 'true' ? 'horizontal' : 'vertical'
    }

    init() {
        this.scroll = new LocomotiveScroll({
            el: this.el,
            smooth: true,
            offset: ['0%'],
            getDirection: true,
            direction: this.direction,
            reloadOnContextChange: true,
            tablet: {
                breakpoint: 1200
            }
        });

        html.setAttribute('data-scroll-theme', '');

        this.scroll.on('call', (func, way, obj, id) => {
            // Using modularJS
            this.call(func[0], { way, obj }, func[1], func[2]);
        });

        ScrollCall.on('call', this.onHScrollCall);

        this.scroll.on('scroll', (args) => {
            if (args.scroll.y > 50) {
                html.classList.add('has-scrolled');
            } else {
                html.classList.remove('has-scrolled');
            }

            if (html.getAttribute('data-direction') != args.direction) {
                html.setAttribute('data-direction', args.direction)
            }

            Object.values(args.currentElements).forEach(item => {
                if (item.el.getAttribute('data-module-culture-icon') !== null) {
                    let progress = item.progress;
                    this.call('progress', progress, 'CultureIcon', item.el.getAttribute('data-module-culture-icon'),);
                }
            });

            // Horizontal progress
            if (typeof args.currentElements['perks'] === 'object') {
                let progress = args.currentElements['perks'].progress;
                this.call('onProgress', progress, 'Perks');
            }

            // Hero progress
            if (typeof args.currentElements['career-hero'] === 'object') {
                let progress = args.currentElements['career-hero'].progress;
                this.call('onProgress', progress, 'CareerHero');
            }

            // Header progress
            if (typeof args.currentElements['header'] === 'object') {
                let progress = args.currentElements['header'].progress;
                this.call('onProgress', progress, 'HeaderProgress');
            }
        })

        // Scroll to for join us form
        if (window.isMobile || window.innerWidth < 1000) {
            setTimeout(() => {
                const hash = window.location.hash.split('?')[0]
                if (hash) {
                    const $target = document.querySelector(hash)
                    $target && this.scrollTo([$target, {
                        duration: 300,
                        offset: -240
                    }])
                }
            }, 200)
        }

        requestAnimationFrame(() => {
            this.update()
        })
    }

    toggleCareerHeroProgress(args) {
        const moduleID = args.obj.el.dataset.moduleCareerHero

        if (args.way === "exit") {
            if (args.obj.progress > 0.5) {
                this.call('forceProgressEnd', null, 'CareerHero', moduleID)
            } else {
                this.call('forceProgressStart', null, 'CareerHero', moduleID)
            }
        }
    }

    toggleHeaderProgress(args) {
        const moduleID = args.obj.el.dataset.moduleHeader

        if (args.way === "exit") {
            if (args.obj.progress > 0.5) {
                this.call('forceProgressEnd', null, 'HeaderProgress', moduleID)
            } else {
                this.call('forceProgressStart', null, 'HeaderProgress', moduleID)
            }
        }
    }

    toggleStickyApplication(args) {
        if (args.way === "enter") {
            html.classList.remove('has-sticky-application');
        } else if (args.way === "exit") {
            html.classList.add('has-sticky-application');
        }
    }

    toggleFooter(args) {
        if (args.way === "enter") {
            html.classList.add('has-footer-inview');
        } else if (args.way === "exit") {
            html.classList.remove('has-footer-inview');
        }
    }

    update() {
        this.scroll.update();
    }

    updateTheme(e) {
        if (e.way === 'enter' && e.obj.isHScroll) {
            html.setAttribute('data-scroll-theme', e.obj.el.getAttribute('data-theme'))
        } else if (e.way === 'enter' && (html.getAttribute('data-direction') === 'down' || html.getAttribute('data-direction') === 'right')) {
            html.setAttribute('data-scroll-theme', e.obj.el.getAttribute('data-theme'))
        }
        if (e.way === 'exit' && (html.getAttribute('data-direction') === 'up' || html.getAttribute('data-direction') === 'left')) {
            if (!e.obj.isHScroll) {
                html.setAttribute('data-scroll-theme', '');
            }
        }
    }

    updateMainTheme(e) {
        if (e.way === 'enter' && (html.getAttribute('data-direction') === 'down' || html.getAttribute('data-direction') === 'right')) {
            html.setAttribute('data-theme', e.obj.el.getAttribute('data-theme'));
        }

        if (e.way === 'exit' && (html.getAttribute('data-direction') === 'up' || html.getAttribute('data-direction') === 'left')) {
            html.setAttribute('data-theme', document.querySelector('[data-load-container]').getAttribute('data-theme'));
        }
    }

    onHScrollCall(func, way, obj, id) {
        // Using modularJS
        this.call(func[0], { way, obj }, func[1], func[2]);
    }

    scrollTo(param) {
        if (this.scroll && this.scroll.scrollTo) this.scroll.scrollTo(param[0], param[1]);
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
        lazyLoadImage(args.obj.el, null, () => {
            //callback
        })
    }

    destroy() {
        this.scroll.destroy();
        html.classList.remove('has-scrolled');
        html.setAttribute('data-scroll-theme', '');
        html.setAttribute('data-direction', '');
    }
}
